module.exports = __webpack_public_path__ + "static/img/9.40e6eb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/9.png
// module id = 5V1v
// module chunks = 0